// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__7LQNw","btn":"styles_btn__3orCy","tags":"styles_tags__1nGAz","input":"styles_input__jwf_G","select":"styles_select__LcdQv","label":"styles_label__2nLar"};